import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { AffiliateDetail } from "@/affiliates/AffiliateEditor";
import {
  AffiliatesPage,
  parseAffiliatesSearch,
} from "@/affiliates/AffiliatesPage";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/affiliates_/$affiliateId",
)({
  validateSearch: parseAffiliatesSearch,
  component: AffiliateDetailRoute,
});

function AffiliateDetailRoute(): ReactNode {
  const { q } = Route.useSearch();
  const { affiliateId } = Route.useParams();
  const navigate = Route.useNavigate();

  return (
    <AffiliatesPage
      query={q ?? ""}
      selectedId={affiliateId}
      onQueryChange={(query) => {
        void navigate({
          replace: true,
          search: { q: query === "" ? undefined : query },
        });
      }}
    >
      <AffiliateDetail affiliateId={affiliateId} query={q} />
    </AffiliatesPage>
  );
}
